export const NDA_STORAGE_KEY = "navig8_nda_record";

export function isUnlocked() {
  return true;
}

export default function SiteAccessGate({ children }) {
  return children;
}
